import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Program } from '@app/app/page-modules/programs/models/program.model';
import { ProgramViewState } from '@app/app/page-modules/programs/store/view/program-view.state';
import { CardsLayoutType } from '@app/app/shared/models';
import { LoadableState } from '@app/app/shared/store';
import { ArrangeIcon, DashboardSquareIcon, LeftToRightListTriangleIcon } from '@hugeicons/core-free-icons/index';
import { Select } from '@ngxs/store';
import { Observable, takeUntil } from 'rxjs';

@Component({
  selector: 'ptl-collections-layout-view',
  templateUrl: './collections-layout-view.component.html',
  styleUrls: ['./collections-layout-view.component.scss'],
})
export class CollectionsLayoutViewComponent implements OnInit, OnDestroy {
  @Input() currentLayoutView: CardsLayoutType = 'CardView';
  @Output() layoutChanged = new EventEmitter<CardsLayoutType>();

  @Select(ProgramViewState.programState)
  programState$: Observable<LoadableState<Program>>;

  program: Program;

  private subscriptionEnd$ = new EventEmitter();

  ngOnInit() {
    this.programState$.pipe(takeUntil(this.subscriptionEnd$)).subscribe((program) => {
      if (program && program.data) {
        this.program = program.data;
      }
    });
  }

  ngOnDestroy() {
    this.subscriptionEnd$.emit();
  }

  onLayoutViewChange(viewType: CardsLayoutType): void {
    this.currentLayoutView = viewType;
    this.layoutChanged.emit(viewType);
  }

  protected readonly DashboardSquareIcon = DashboardSquareIcon;
  protected readonly LeftToRightListTriangleIcon = LeftToRightListTriangleIcon;
  protected readonly ArrangeIcon = ArrangeIcon;
}
